var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("suc-calendar-component", {
    attrs: { type: _vm.type, cellData: _vm.cellData, isLoading: _vm.isLoading },
    on: _vm._d({}, [_vm.getCalendarDataEvent, _vm.init]),
    scopedSlots: _vm._u([
      {
        key: "cell",
        fn: function (props) {
          return [
            _c("suc-calendar-item-component", {
              attrs: { cell: props.cell },
              scopedSlots: _vm._u(
                [
                  {
                    key: "body",
                    fn: function (props) {
                      return [
                        _c("vacation-content-component", {
                          attrs: { cell: props.cell },
                        }),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            }),
          ]
        },
      },
      {
        key: "foot",
        fn: function () {
          return [
            _c("tr", [
              _c("td", { attrs: { colspan: "7" } }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("vacation-confirm-waiting-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacations-approved-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacations-need-meeting-day-legend", {
                        staticClass: "m-1",
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }